import { ColDef, GridOptions } from 'ag-grid-community';

export const columnDefs: ColDef[] = [
  {
    headerName: 'S.No',
    valueGetter: (params) => (params.node ? params.node.rowIndex + 1 : null),
    minWidth: 80,
    maxWidth: 100,
    suppressMenu: true,
    sortable: false,
    cellClass: 'px-center-cell',
    headerClass: 'px-center-cell',
  },
  {
    headerName: 'Release',
    field: 'release',
    minWidth: 150,
    sortable: true,
    wrapText: true,
    autoHeight: true,
    cellStyle: {
      wordBreak: 'break-all',
    },
  },
  {
    headerName: 'ID',
    field: 'id',
    minWidth: 80,
    maxWidth: 100,
    sortable: false,
    cellClass: 'px-center-cell',
    headerClass: 'px-center-cell',
  },
  {
    headerName: 'Approvers',
    field: 'approvers',
    valueGetter: (params) =>
      Array.isArray(params.data?.approvers) && params.data.approvers.length > 0
        ? params.data.approvers.join(', ')
        : '--',
    minWidth: 180,
    sortable: true,
    wrapText: true,
    autoHeight: true,
    cellStyle: {
      wordBreak: 'break-word',
    },
  },
  {
    headerName: 'Query',
    field: 'query',
    valueGetter: (params) => params.data?.query || params.data?.sql || '--',
    flex: 3,
    minWidth: 300,
    autoHeight: true,
    wrapText: true,
    cellStyle: {
      fontFamily: 'monospace',
      fontSize: '12px',
      lineHeight: '1.4',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-all',
    },
  },
];

export const columnDefsV3: ColDef[] = [
  {
    headerName: 'S.No',
    valueGetter: (params) => (params.node ? params.node.rowIndex + 1 : null),
    minWidth: 80,
    maxWidth: 100,
    suppressMenu: true,
    sortable: false,
    cellClass: 'px-center-cell',
    headerClass: 'px-center-cell',
  },
  {
    headerName: 'Release',
    field: 'release',
    minWidth: 150,
    sortable: true,
    wrapText: true,
    autoHeight: true,
    cellStyle: {
      wordBreak: 'break-all',
    },
  },
  {
    headerName: 'ID',
    field: 'id',
    minWidth: 80,
    maxWidth: 100,
    sortable: false,
    cellClass: 'px-center-cell',
    headerClass: 'px-center-cell',
  },
  {
    headerName: 'Type',
    field: 'type',
    valueGetter: (params) => params.data?.type || '--',
    minWidth: 120,
    sortable: true,
    wrapText: true,
    autoHeight: true,
    cellStyle: {
      wordBreak: 'break-word',
    },
  },
  {
    headerName: 'Tenant ID',
    field: 'tenantId',
    valueGetter: (params) =>
      params.data?.tenantId || params.data?.tenant_id || params.data?.tenantid || '--',
    minWidth: 140,
    sortable: true,
    wrapText: true,
    autoHeight: true,
    cellStyle: {
      wordBreak: 'break-word',
    },
  },
  {
    headerName: 'Approvers',
    field: 'approvers',
    valueGetter: (params) =>
      Array.isArray(params.data?.approvers) && params.data.approvers.length > 0
        ? params.data.approvers.join(', ')
        : '--',
    minWidth: 180,
    sortable: true,
    wrapText: true,
    autoHeight: true,
    cellStyle: {
      wordBreak: 'break-word',
    },
  },
  {
    headerName: 'Query',
    field: 'query',
    valueGetter: (params) => params.data?.query || params.data?.sql || '--',
    flex: 3,
    minWidth: 300,
    autoHeight: true,
    wrapText: true,
    cellStyle: {
      fontFamily: 'monospace',
      fontSize: '12px',
      lineHeight: '1.4',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-all',
    },
  },
];

export const formatValueWithFallback = (params: any) => {
  const val = params.value;
  if (val === null || val === undefined || val === '' || (Array.isArray(val) && val.length === 0)) {
    return '--';
  }
  return val;
};

export const gridOptions: GridOptions = {
  defaultColDef: {
    sortable: false,
    resizable: true,
    filter: false,
    suppressMenu: true,
    lockPosition: true,
    valueFormatter: formatValueWithFallback,
  },
  domLayout: 'normal' as const,
  enableCellTextSelection: true,
  suppressMovableColumns: true,
  getRowStyle: () => ({
    borderBottom: '1px solid #e0e0e0',
  }),
};
